import styled, { css } from "styled-components";
import { breakpointProp } from "../../../mixins/breakpointProp";
import { rem } from "../../../mixins/formatters";
import iconMixin from "../../../mixins/icon";
import { calculateIconSize, } from "../../../mixins/iconSize";
import isPropValid from "@emotion/is-prop-valid";
export const customIconSizeMixin = css `
  ${breakpointProp("_size", (v) => `width: ${rem(calculateIconSize(v))};`)};
`;
export const Icon = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  svg {
    width: 100%;
    height: 100%;
  }

  ${iconMixin};

  &.customSvg {
    ${customIconSizeMixin}
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWNvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ljb24vc3R5bGVkL0ljb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLEVBQUUsRUFBRSxHQUFHLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUNoRCxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sZ0NBQWdDLENBQUM7QUFDaEUsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLDRCQUE0QixDQUFDO0FBQ2pELE9BQU8sU0FBNkIsTUFBTSxzQkFBc0IsQ0FBQztBQUNqRSxPQUFPLEVBQ0wsaUJBQWlCLEdBRWxCLE1BQU0sMEJBQTBCLENBQUM7QUFDbEMsT0FBTyxXQUFXLE1BQU0sd0JBQXdCLENBQUM7QUFFakQsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQUcsR0FBRyxDQUFvQjtJQUN0RCxjQUFjLENBQUMsT0FBTyxFQUFFLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxVQUFVLEdBQUcsQ0FBQyxpQkFBaUIsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUM7Q0FDekUsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLElBQUksR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQztJQUN4QyxpQkFBaUIsRUFBRSxXQUFXO0NBQy9CLENBQUMsQ0FBZ0I7Ozs7OztJQU1kLFNBQVM7OztNQUdQLG1CQUFtQjs7Q0FFeEIsQ0FBQyJ9